const CountyAndRegion = {
  'Capital District': [
    "Alamance",
    "Chatham",
    "Durham",
    "Franklin",
    "Granville",
    "Harnett",
    "Johnston",
    "Orange",
    "Person",
    "Warren",
    "Vance",
    "Wake"
  ],
  'Coastal District':  [
    "Brunswick",
    "Carteret",
    "Columbus",
    "Craven",
    "Duplin",
    "Jones",
    "New Hanover",
    "Onslow",
    "Pamlico",
    "Pender"
  ],
  'Northeastern District': [
    "Beaufort",
    "Bertie",
    "Camden",
    "Chowan",
    "Currituck",
    "Dare",
    "Edgecombe",
    "Gates",
    "Greene",
    "Halifax",
    "Hertford",
    "Hyde",
    "Lenoir",
    "Martin",
    "Nash",
    "Northampton",
    "Pasquotank",
    "Perquimans",
    "Pitt",
    "Tyrrell",
    "Wayne",
    "Wilson",
    "Washington"
  ],
  'Northwestern District': [
    "Alexander",
    "Alleghany",
    "Ashe",
    "Avery",
    "Burke",
    "Caldwell",
    "Catawba",
    "Davie",
    "Iredell",
    "Surry",
    "Watauga",
    "Wilkes",
    "Yadkin"
  ],
  'Southeastern District': [
    "Bladen",
    "Cumberland",
    "Hoke",
    "Lee",
    "Moore",
    "Richmond",
    "Robeson",
    "Sampson",
    "Scotland"
  ],
  'Southern Piedmont District': [
    "Anson",
    "Cabarrus",
    "Cleveland",
    "Gaston",
    "Lincoln",
    "Mecklenburg",
    "Rowan",
    "Stanly",
    "Union"
  ],
  'Western District': [
    "Buncombe",
    "Cherokee",
    "Clay",
    "Graham",
    "Haywood",
    "Henderson",
    "Jackson",
    "Macon",
    "Madison",
    "McDowell",
    "Mitchell",
    "Polk",
    "Rutherford",
    "Swain",
    "Transylvania",
    "Yancey"
  ],
  'Northern Piedmont District': [
    "Stokes",
    "Rockingham",
    "Caswell",
    "Forsyth",
    "Guilford",
    "Alamance",
    "Davidson",
    "Randolph",
    "Montgomery"
  ]
};

export default CountyAndRegion;